<template>
  <ButtonBase class="button-close" v-bind="$attrs" v-on="$listeners">
    <slot>{{ $t('ui.close') }}</slot>
  </ButtonBase>
</template>

<script>
import ButtonBase from '../ButtonBase';

export default {
  name: 'ButtonClose',

  components: { ButtonBase },
};
</script>

<style lang="scss" scoped>
.button-close {
  text-decoration: underline;
  color: $color-white;
  padding: 25px 20px;
  transition: 0.3s ease;
  @include helper__composited-layer();

  &:active {
    transform: scale(0.98);
    opacity: 0.8;
  }
}
</style>
